import { Button, Flex, Rate, Typography } from 'antd';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import pdi from './ProductDistributorItem.module.scss';

const ProductDistributorItem = ({
    isViewer,
    openLoginForm,
    item,
    changeBasketProduct,
    productData,
    product_query,
    isSelectedToBasket,
}: any) => {
    const LOCALIZATION = useLocalization();
    return (
        <Flex
            vertical
            className={pdi.container}
        >
            <Flex
                className={pdi.headerBlock}
                gap={'1rem'}
            >
                <Typography.Text className={`text-16-400 text-[#0B0B0C]`}>Компания</Typography.Text>
                <Typography.Text className={`text-16-400 text-[#8D24F8]`}>
                    {productData?.manufacture?.slug == item?.organisation?.slug
                        ? 'От производителя'
                        : item?.organisation?.name}
                </Typography.Text>
            </Flex>
            <Flex
                className={pdi.headerBlock}
                justify={'space-between'}
            >
                <Typography.Text className={`text-20-500 text-[#0B0B0C]`}>
                    {item?.price} {item?.unit}
                </Typography.Text>
                <Button
                    type={isSelectedToBasket ? 'primary' : 'default'}
                    onClick={() => {
                        if (isViewer) openLoginForm();
                        else {
                            console.log('THISSSS', item);
                            changeBasketProduct(item?.organisation?.slug, product_query);
                        }
                    }}
                >
                    {isSelectedToBasket
                        ? LOCALIZATION.pages.product.rightCard.isSelectedToBasket.true
                        : LOCALIZATION.pages.product.rightCard.isSelectedToBasket.false}
                </Button>
            </Flex>
            <Flex
                className={pdi.distributerBlock}
                gap={'small'}
            >
                <Rate value={5} />
                <Typography.Text className={`text-12-400 text-[#7B7C7D]`}>
                    5 отзывов
                </Typography.Text>
            </Flex>
            <Flex className={pdi.distributerDelivery}>
                <Typography.Text className={`text-16-400 text-[#7B7C7D]`}></Typography.Text>
            </Flex>
            <Flex className={pdi.distributerPlace}>
                <Typography.Text className={`text-16-400 text-[#0B0B0C]`}></Typography.Text>
            </Flex>
        </Flex>
    );
};

export default ProductDistributorItem;
